import { AxiosError } from 'axios';
import { useQuery, UseQueryResult, UseQueryOptions } from '@tanstack/react-query';
import { couponQueryKeys } from '../../../constants/queryKeys/coupon';
import { CouponApiV2 } from '../../../lib/api/coupon/CouponApiV2';

type UnUsageHistoryResponse = Awaited<ReturnType<typeof CouponApiV2.getCouponUnUsageHistoryList>>;

type UnUsageHistoryOption = {
  couponId: number;
  filterOption: Record<string, unknown>;
  pagination: { pageNum: number; pageSize: number };
};

type UnUsageHistoryData = {
  list: Record<string, unknown>[];
  totalCnt: number;
  filterOption: Record<string, unknown>;
  pagination: { pageNum: number; pageSize: number; pages: number; totalCnt: number };
};

export const useCouponUnUsageHistoryQuery = (
  option: UnUsageHistoryOption,
  options?: UseQueryOptions<UnUsageHistoryResponse, AxiosError, UnUsageHistoryData>,
): UseQueryResult<UnUsageHistoryData, AxiosError> => {
  return useQuery(
    couponQueryKeys.couponUnUsageHistory(option.couponId, option),
    () => CouponApiV2.getCouponUnUsageHistoryList(option),
    {
      select: (res: UnUsageHistoryResponse) => {
        const totalCnt = res.data.totalCnt ?? 0;
        return {
          list: res.data.couponUnUsageHistoryList ?? [],
          totalCnt,
          filterOption: option.filterOption,
          pagination: {
            pageNum: option.pagination.pageNum,
            pageSize: option.pagination.pageSize,
            pages: Math.ceil(totalCnt / Math.max(1, option.pagination.pageSize)) || 1,
            totalCnt,
          },
        };
      },
      enabled: !!option.couponId,
      ...options,
    },
  );
};
